import { STRING, DATE, TIME, DATETIME, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'

export default {
  label: 'Is',
  operator: 'is',
  fields: [ STRING, DATE, TIME, DATETIME, ITEM, COLLECTION ],
  isValidValue (value) {
    return isDate(value) || (!isArray(value) && isObject(value)) || ((isArray(value) || isString(value)) && value.length)
  }
}
